export default {
      id: "step-complete-usage",
      viewBox: "0 0 158 158",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#step-complete",
      toString: function () {
        return this.url;
      }
    }